import getUtils from './../mixins/getMixins'
import { flatten } from 'lodash'

// 处理模版中的Title组件
const _transformTitle = montageTemplate => {
    const fieldList = montageTemplate.templateFieldParamList || []
    const firstTitleIndex = fieldList.findIndex(
        field => field.formType === 'Title'
    )
    if (firstTitleIndex === -1) {
        return montageTemplate
    }
    // 设置一个移动的游标
    let n = 0
    const titleIndexArr = []
    const titleArr = []
    const targetIndexArr = []
    while (n < fieldList.length) {
        if (fieldList[n].formType === 'Title') {
            titleIndexArr.push(n)
            titleArr.push(fieldList[n])
        }
        n++
    }
    titleIndexArr.forEach((titleIndex, index, arr) => {
        if (index === 0) {
            if (titleIndex === 0) {
                targetIndexArr.push([titleIndex + 1, arr[index + 1]])
            } else {
                targetIndexArr.push([0, titleIndex])
                targetIndexArr.push([titleIndex + 1, arr[index + 1]])
            }
        } else if (index + 1 === arr.length) {
            targetIndexArr.push([titleIndex + 1, fieldList.length])
        } else {
            targetIndexArr.push([titleIndex + 1, arr[index + 1]])
        }
    })
    const targetArr = targetIndexArr.map(indexArr =>
        fieldList.slice(...indexArr)
    )
    if (targetIndexArr.length > titleArr.length) {
        return targetArr.map((t, index) => {
            if (index === 0) {
                return {
                    ...montageTemplate,
                    templateFieldParamList: t
                }
            } else {
                return {
                    ...montageTemplate,
                    templateFieldParamList: t,
                    templateName: titleArr.map(field => field.fieldName)[
                        index - 1
                    ]
                }
            }
        })
    } else {
        return targetArr.map((t, index) => ({
            ...montageTemplate,
            templateFieldParamList: t,
            templateName: titleArr.map(field => field.fieldName)[index]
        }))
    }
}

// 多模版处理
const transformTitle = res =>
    flatten(
        getUtils.methods
            .getMontageTemplateList(res)
            .map(montageTemplate => _transformTitle(montageTemplate))
    ).map((t, index) => ({ ...t, _id: index }))

export default transformTitle
